import Immutable from 'immutable';

import type ErrorData from 'sharedreact/data/ErrorData';
import SortOrder from 'sharedreact/data/SortOrder';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

import AgentsConnection from 'workspaces/launcher/connections/AgentsConnection';
import AgentsConstants from 'workspaces/launcher/constants/AgentsConstants';
import Agent from 'workspaces/launcher/data/Agent';

function _fetchSuccess (items: Immutable.List<Agent>) {
  AppDispatcher.dispatch({
    actionType: AgentsConstants.GET_SUCCESS,
    items: items,
    logLevel: 'debug'
  });
}

function _fetchFailure (error: ErrorData) {
  AppDispatcher.dispatch({
    actionType: AgentsConstants.GET_FAIL,
    error: error,
    logLevel: 'debug'
  });
}

function fetch () {
  AgentsConnection.fetch(_fetchSuccess, _fetchFailure);
}

function _removeSuccess (
  ids: Immutable.List<string>
  ) {
  AppDispatcher.dispatch({
    actionType: AgentsConstants.REMOVE_SUCCESS,
    ids: ids,
    logLevel: 'trace'
  });
}

function _removeFailure (error: ErrorData) {
  AppDispatcher.dispatch({
    actionType: AgentsConstants.REMOVE_FAIL,
    error: error,
    logLevel: 'trace'
  });
}

function remove (identifiers: Immutable.List<string>) {
  AppDispatcher.dispatch({
    actionType: AgentsConstants.REMOVE,
    logLevel: 'trace'
  });
  AgentsConnection.removeAgents(identifiers, _removeSuccess, _removeFailure);
}

function setSortOrder (sortOrder: SortOrder): void {
  AppDispatcher.dispatch({
    actionType: AgentsConstants.SET_SORTORDER,
    sortOrder: sortOrder,
    logLevel: 'trace'
  });
}

const AgentsActions = {
  fetch,
  remove,
  setSortOrder
};

export default AgentsActions;
